import React from 'react';
import PropTypes from 'prop-types';

import { Button } from '@ps-design-system/components/Button';
import { Text } from '@ps-design-system/components/Text';

const UploadMediaCardMobile = ({ startIcon, heading, body, helperText, buttonLabel, buttonIcon, onClick }) => {
  return (
    <div className='uploader-media-card tw-border tw-border-gray-400'>
      <div className='header-container'>
        <div className='title-container'>
          <div>
            {startIcon}
          </div>
          <div>
            <Text typeface="headline-2-m">{heading}</Text>
          </div>
        </div>
        <Button
          appearance="black"
          suffix={buttonIcon}
          onClick={onClick}
        >
          {buttonLabel}
        </Button>
      </div>
      <Text typeface="body-2">{body}</Text>
      <Text className='tw-text-gray-600' typeface="body-1">{helperText}</Text>
    </div>
  );
};

UploadMediaCardMobile.propTypes = {
  startIcon: PropTypes.node,
  heading: PropTypes.node,
  body: PropTypes.node,
  helperText: PropTypes.node,
  buttonLabel: PropTypes.string,
  buttonIcon: PropTypes.node,
  onClick: PropTypes.func
};

UploadMediaCardMobile.defaultProps = {
  startIcon: null,
  heading: null,
  body: null,
  helperText: null,
  buttonLabel: '',
  buttonIcon: null,
  onClick: () => {}
};

export default UploadMediaCardMobile;
